module.exports = {
      id: "follow-x-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "svg-sprite.svg#follow-x",
      toString: function () {
        return this.url;
      }
    }